import { Avatar, Flex, useDisclosure } from "@chakra-ui/react";
import { DeleteConfirmationModal, EditableName } from "@pufflig/prompt-studio-ui";
import { useRef } from "react";

interface TeamHeaderProps {
  canEdit: boolean;
  teamName: string;
  onRename?: (newName: string) => void;
  onDelete: () => void;
}

export const TeamHeader = (props: TeamHeaderProps) => {
  const { teamName, canEdit, onRename, onDelete } = props;
  const { isOpen: isDeleteModalOpen, onClose: onCloseDeleteModal, onOpen: onOpenDeleteModal } = useDisclosure();
  const ref = useRef(null);

  return (
    <Flex alignItems="center" gap="spacing-md" ref={ref}>
      <Avatar
        size="lg"
        color="foreground.primary"
        backgroundColor="background.accent-secondary.red-light"
        name={teamName}
        textStyle="heading/2"
        borderRadius="18px"
        borderColor="white"
        borderWidth="2px"
      />
      <Flex alignItems="center" textStyle="heading/1">
        <EditableName
          containerRef={ref}
          canEdit={canEdit}
          name={teamName}
          onBlur={(newName) => {
            onRename?.(newName);
          }}
          onDelete={onOpenDeleteModal}
        />
      </Flex>
      <DeleteConfirmationModal
        headline="Delete Team"
        notificationText="You are about to delete this team. This action cannot be undone. Are you sure?"
        buttonText="Delete Team"
        isOpen={isDeleteModalOpen}
        onClose={() => {
          onCloseDeleteModal();
        }}
        onDelete={onDelete}
      />
    </Flex>
  );
};
